import { IESApiClient } from '@serodigital/ies-api-client';
import { getValidatedAuthToken } from './auth0';

export * from '@serodigital/ies-api-client';

let client: IESApiClient;

export const getGqlClient = async () => {
  if (!client) {
    client = new IESApiClient(
      APP_CONFIG.apiBaseUrl,
      {
        type: 'jwt',
        token: await getValidatedAuthToken(),
      },
      true,
    );
  }

  return client;
};
